import * as actionTypes from './actionTypes';

export const getDeepLinkRequest = () => {
    return {
        type: actionTypes.GET_DEEP_LINK_REQUEST,
    } as const;
};

export const getDeepLinkSuccess = (payload: string) => {
    return {
        type: actionTypes.GET_DEEP_LINK_SUCCESS,
        payload,
    } as const;
};

export const getDeepLinkError = (payload: Error) => {
    return {
        type: actionTypes.GET_DEEP_LINK_ERROR,
        payload,
    } as const;
};
